import { Component, ElementRef, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NgbActiveModal, NgbDateParserFormatter, NgbDateStruct, NgbDatepickerI18n, NgbModal, NgbTimeStruct, NgbTimepicker } from '@ng-bootstrap/ng-bootstrap';
import { Config } from 'app/config.const';
import { MeasureService } from 'app/measure.service';
import { IAppuntamento } from 'app/model/appuntamento';
import { Contatti } from 'app/model/contatti';
import { CustomDateParserFormatter, CustomDatepickerI18n } from 'app/model/datepicker';
import { ImpostazioniGenerali } from 'app/model/impostazioni_generali';
import { Pazienti } from 'app/model/pazienti';
import { ISubject } from 'app/model/soggetto';
import * as moment from 'moment';
import { Observable } from 'rxjs/Observable';
import { combineLatest, debounceTime, map } from 'rxjs/operators';
import { isString } from 'util';
import { toNgbDateStruct } from 'utils';
import { RESTObject } from '../../angular-rest';
import { Impostazioni } from '../../model/impostazioni_agenda';
import { DomandeRisposteAppuntamentoComponent } from '../../opzioni/domande-risposte-appuntamento/domande-risposte-appuntamento';
import { search } from '../../ricerca.soggetti';

@Component({
	selector: 'app-newevent',
	templateUrl: './newEvent.html',
	styleUrls: ['./newEvent.css'],
	providers: [
		{ provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
		{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }
	]
})
export class NewEventComponent {
	// BAU!
	//       __
	//  (___()'`;
	//  /,    /`
	//  \\"--\\
	@ViewChildren(NgbTimepicker, { read: ElementRef })
	set picker(value: QueryList<ElementRef>) {
		// Diciamo grazie ai tizi di bootstrap.
		for (let el of value.map(c => c.nativeElement as HTMLElement)) {
			let list = el.querySelectorAll(".btn-link");
			for (var i = 0; i < list.length; i++) {
				(list.item(i) as HTMLElement).tabIndex = -1;
			}
		}
	}

	@ViewChild('inputPazienti') private elementRef: ElementRef;

	// FIXME tutto i italiano o tutto in inglese.
	public settings$: RESTObject<Impostazioni>;
	hideTime = false;
	eventoRicorrente = false;
	ripetiOgniValue: number = 1;
	ripetiOgniMeasure: string = "day";
	stopCondition: string = "occorrenze";
	numeroRipetizioni?: number = 2;
	repeatEndDate?: NgbDateStruct;
	date: NgbDateStruct = null;
	inizio: NgbTimeStruct = { hour: 0, minute: 0, second: 0 };
	fine: NgbTimeStruct = { hour: 0, minute: 0, second: 0 };
	event: IAppuntamento;
	show = false;
	mobileView: boolean;
	formGroup = new FormGroup({
		categoria: new FormControl(),
		soggetto: new FormControl(),
		citta: new FormControl(),
		indirizzo: new FormControl(),
		numciv: new FormControl(),
		pr: new FormControl(),
		cap: new FormControl()
	});

	constructor(
		public activeModal: NgbActiveModal,
		public impostazioni: ImpostazioniGenerali,
		private contatti: Contatti,
		private pazienti: Pazienti,
		measureService: MeasureService,
		private readonly modalService: NgbModal
	) {

		moment.locale('it');
		this.mobileView = measureService.isMobile();
	}

	get newEvent(): boolean {
		return this.event && +this.event.id < 0;
	}

	ngAfterViewInit() {
		this.elementRef.nativeElement.focus();
	}

	isWeekend(date: NgbDateStruct) {
		return moment({
			year: date.year,
			month: date.month - 1,
			day: date.day
		}).weekday() > 4;
	}

	setEvento(event: IAppuntamento) {
		this.event = event;
		if (this.event.evento == null && this.event.categoria == null) {
			this.event.categoria = "Paziente";
			this.event.evento = "Visita ambulatoriale";
		}

		const i: moment.Moment = moment.utc(event.start);

		this.date = {
			year: i.get('year'),
			month: i.get('month') + 1,
			day: i.get('date')
		};


		if (!event.end) {
			this.hideTime = true;
		} else {
			const f: moment.Moment = moment.utc(event.end);
			this.inizio = { hour: i.get('hour'), minute: i.get('minute'), second: i.get('second') };
			this.fine = { hour: f.get('hour'), minute: f.get('minute'), second: f.get('second') };
		}
	}

	setCategoria(evento: string) {
		this.event.evento = evento;

		// FIXME: Che cazzo è questo?
		let cat = (function () {
			return $(':selected', this).closest('optgroup').attr('label');
		})();

		if (cat) {
			this.event.categoria = cat;
		}
	}

	setAllDay() {
		if (this.hideTime) {
			this.event.end = null;
		}
	}

	Date = toNgbDateStruct;

	format() {
		if (!this.hideTime) {
			const i: moment.Moment = moment.utc({
				day: this.date.day,
				month: this.date.month - 1, // La scomodità
				year: this.date.year,
				hour: this.inizio.hour,
				minute: this.inizio.minute,
				second: 0
			});
			const f: moment.Moment = moment.utc({
				day: this.date.day,
				month: this.date.month - 1, // La scomodità
				year: this.date.year,
				hour: this.fine.hour,
				minute: this.fine.minute,
				second: 0
			});
			this.event.start = i;
			this.event.end = f;
		} else {
			const i: moment.Moment = moment.utc({
				day: this.date.day,
				month: this.date.month - 1, // La scomodità
				year: this.date.year
			});
			this.event.start = i;
		}
	}

	check() {
		return (this.inizio.hour < this.fine.hour) ||
			(
				(this.inizio.hour === this.fine.hour) &&
				(this.inizio.minute < this.fine.minute)
			);
	}

	valid() {
		return this.formGroup.valid &&
			this.event.evento && this.event.categoria &&
			(this.event.start || this.date) &&
			(this.check() || this.hideTime);
	}

	upsert() {
		this.format();

		this.activeModal.close(<IAppuntamento>{
			id: this.event.id,
			title: this.event.title,
			start: this.event.start,
			end: this.event.end,
			indirizzo: this.event.indirizzo,
			numciv: this.event.numciv,
			citta: this.event.citta,
			CAP: this.event.CAP,
			provincia: this.event.provincia,
			descrizione: this.event.descrizione,
			categoria: this.event.categoria,
			evento: this.event.evento,
			version: +this.event.version + 1,
			status: this.event.status,
			repeat: this.eventoRicorrente ? {
				type: this.stopCondition,
				increment: this.ripetiOgniValue,
				incrementUnit: this.ripetiOgniMeasure,
				incrementNumber: this.numeroRipetizioni,
				incrementUntil: this.repeatEndDate ? moment.utc({
					day: this.repeatEndDate.day,
					month: this.repeatEndDate.month - 1,
					year: this.repeatEndDate.year
				}) : undefined,
			} : undefined
		});
	}

	cancella() {
		if (confirm("Procedere con la cancellazione dell'appuntamento?")) {
			this.activeModal.close({ delete: +this.event.id });
		}
	}

	cancella_gruppo() {
		this.activeModal.close({ delete_group: +this.event.group_id });
	}

	toggleShow() {
		this.show = !this.show;
	}

	contactSearch = (terms$: Observable<string>) => {
		return terms$.pipe(
			debounceTime(Config.searchDebounceTime),
			combineLatest(this.contatti.pipe()),
			map(([term, subjects]) => search(term, subjects, i => i))
		);
	}

	pazientiSearch = (terms$: Observable<string>) => {
		return terms$.pipe(
			debounceTime(Config.searchDebounceTime),
			combineLatest(this.pazienti.pipe()),
			map(([term, subjects]) => search(term, subjects, i => i))
		);
	}

	contactFormat(result: ISubject) {
		if (isString(result)) {
			return result;
		} else {
			return `${result.cognome} ${result.nome}`;
		}
	}

	fillInFromSubject = (subject: string | ISubject) => {
		if (isString(subject)) {
			this.event.title = subject as string;
		} else {
			const contatto = subject as ISubject;
			this.show = true;

			if (contatto.medico) {
				this.event.title = `${contatto.cognome} ${contatto.nome} - Dr. ${contatto.medico}`;
			} else {
				this.event.title = `${contatto.cognome} ${contatto.nome}`;
			}

			this.event.citta = contatto.citta == null ? "" : contatto.citta.trim();
			this.event.indirizzo = contatto.indirizzo == null ? "" : contatto.indirizzo.trim();
			this.event.numciv = contatto.numciv == null ? "" : contatto.numciv.trim();
			this.event.provincia = contatto.pr == null ? "" : contatto.pr.trim();
			this.event.CAP = contatto.cap == null ? "" : contatto.cap.trim();
			this.event.codice_fiscale = contatto.codfis == null ? "" : contatto.codfis.trim();
		}
	}

	mostraRisposte() {
		const modalRef = this.modalService.open(DomandeRisposteAppuntamentoComponent)

		modalRef.componentInstance.idAppuntamento = this.event.id
	}
}



// WEBPACK FOOTER //
// ./src/app/calendar/newEvent/newEvent.ts